// "The short answer" boxes shown directly under a blog post's heading.
// One entry per post, keyed by slug. Each answer is two or three plain
// sentences taken from the post itself, so Google can quote it as a direct
// answer. Keep the wording in line with the post when either changes.

export const SHORT_ANSWERS = {
  'how-much-does-it-cost-to-paint-a-room-in-kent-2026': {
    question: 'How much does it cost to paint a room in Kent?',
    answer: [
      'For an average bedroom or home office in good condition, including walls, ceilings and woodwork, most of our Kent clients spend somewhere in the low hundreds.',
      'Larger rooms, high ceilings, feature colours, repairs and awkward areas such as halls, stairs and landings push the price up. One light colour throughout and good trade paints keep it down.',
      'You always get a written quote before we start, so you know exactly what is included.',
    ],
  },
  'exterior-house-painting-kent-how-long-does-it-last': {
    question: 'How long does exterior house painting last in Kent?',
    answer: [
      'As a broad guide, good quality masonry paint on properly prepared render lasts around 8 to 10 years, and timber windows and doors usually need a refresh every 4 to 6 years.',
      'Fences, sheds and cabins may need attention more often, especially on exposed sides. Coastal and exposed sites weather faster.',
      'Preparation matters more than the brand of paint: washing down, treating algae, sanding back failing paint and priming bare areas are what make it last.',
    ],
  },
  'painter-decorator-near-me-kent-what-to-look-for': {
    question: 'What should I look for in a painter and decorator near me in Kent?',
    answer: [
      'Check independent reviews, such as Checkatrade, for comments on punctuality, sticking to the quote and leaving the property clean.',
      'Ask whether they focus on one job at a time and will be there every day until it is finished, and get a written quote that sets out the rooms, preparation, number of coats and materials.',
      'Make sure they have worked on your type of property, from new builds to older solid wall homes.',
    ],
  },
  'how-to-prepare-your-kent-home-for-painters': {
    question: 'How do I prepare my home for painters?',
    answer: [
      'Agree the rooms, order, colours and access arrangements before work starts, and tell us early if anything changes.',
      'Take down pictures, mirrors and shelves, pack away ornaments and breakables, and decide which furniture can stay in the middle of the room and which should go elsewhere.',
      'Plan where pets and children will be, and tell us about important calls so we can schedule noisier work around them. We protect floors and furniture and tidy at the end of each day.',
    ],
  },
  'landlords-guide-between-tenant-refreshes-kent': {
    question: 'What does a between tenant decorating refresh include?',
    answer: [
      'Usually walls and ceilings in the main rooms and bedrooms, woodwork and radiators, and the hall, stairs and landing, with small patches of damp, staining or hairline cracks sorted out first.',
      'We plan the work around check out, cleaning and inventory to keep the void period short, and can hold keys and send daily photo and video updates if you cannot get to the property.',
      'Durable, wipeable paints in neutral colours stand up best to tenants.',
    ],
  },
  'office-shop-repaints-without-shutting-doors': {
    question: 'Can you repaint an office or shop without closing?',
    answer: [
      'Usually, yes. We work outside your main trading hours where possible, split the job into phases so parts of the space stay usable, and schedule dusty or noisy preparation for quieter times.',
      'Floors, stock, equipment and key routes are protected, and we tidy thoroughly at the end of each day so you can open as normal.',
    ],
  },
  'sash-window-timber-painting-kent-repair-or-replace': {
    question: 'Should I repair or replace my sash windows?',
    answer: [
      'If the timber is mostly sound, refurbishing and repainting is usually significantly cheaper than replacement and can add years to the life of the windows.',
      'A decorator can scrape back failing paint, treat minor rot, replace failed putty, prime bare wood and apply long lasting top coats. Where there is serious structural damage, a specialist joiner repairs it first.',
      'Replacement is the better long term option where rot is widespread or frames are structurally unsound. We inspect before pricing and will tell you which applies.',
    ],
  },
  'why-roof-pressure-washing-gives-biggest-visual-change': {
    question: 'Why does a roof clean make the biggest visual difference?',
    answer: [
      'The roof is one of the largest visible surfaces on your property, and moss, algae and dark streaks on the tiles dull the whole house.',
      'Pressure washing it brings back much of the original tile colour, and the change is visible the moment the work is finished. Adding the drive, patio or decking on the same visit is usually more cost-effective than booking them separately.',
    ],
  },
  'roof-drive-decking-planning-one-pressure-washing-visit': {
    question: 'Should I get my roof, drive and decking cleaned in one visit?',
    answer: [
      'Usually, yes. Start with the roof for the biggest impact, then clean the drive and decking the same day so they do not look worse next to a clean roof.',
      'Sharing set-up and access equipment across the jobs means one period of disruption, and the overall cost is often lower than booking each area separately.',
    ],
  },
};
